import type { Follow } from "@tandemdiabetes/sugarmate-api-react-client"
import { useCallback } from "react"
import { useSegment } from "src/contexts/SegmentContext"

export function useTrackSleepSettings() {
  const analyticsRef = useSegment()

  return useCallback(
    (sleepSettings: Follow["sleep_settings"]) => {
      const {
        start_time,
        end_time,
      } = sleepSettings

      void analyticsRef.current.track(
        "Sleep Hours Set",
        {
          "Sleep Start": start_time,
          "Sleep End": end_time,
        },
      )
    },
    [analyticsRef],
  )
}
